// extracted by mini-css-extract-plugin
export var borderRadius = "_f1-4";
export var large = "_f1-3";
export var logoContainer = "_f1-0";
export var nameLogo = "_f1-2";
export var small = "_f1-1";